const focusLock = ({
	elements,
	sizes,
	controlledBy,
}) => {

	const focusableElements = [
		'a',
		'input',
		'button',
		'select',
		'textarea',
	];

	if (!Array.isArray(elements)) {
		return;
	}

	const listeners = elements.map(element => {
		if (!element) {
			return;
		}
		const tabbableContents = element.querySelectorAll(focusableElements.join(', '));

		const tabListener = e => {
			// this needs to be done every time the user tabs
			// because it relies on getComputedStyle to find
			// out if an element is hidden, so needs to calculate
			// each time to remain updated with the applied css
			const contents = Array.prototype
				.slice.call(tabbableContents)
				.filter(elem => !elem.matches('.js__excluded-from-focus-lock'))
				.filter(elem => !elem.matches('[disabled]'))
				.filter(elem => {
					return window.getComputedStyle(elem).visibility !== 'hidden'
						&& elem.offsetParent !== null;
				});

			const start = contents[0];
			const end = contents[contents.length - 1];

			const keyIsNotTab = e.key !== 'Tab';
			const windowTooNarrow = window.innerWidth < sizes[0];
			const windowTooWide = window.innerWidth > sizes[1];

			let controllerIsInactive;

			if (controlledBy === element) {
				controllerIsInactive = false;
			} else {
				controllerIsInactive = controlledBy.getAttribute('aria-expanded') !== 'true';
			}

			if (
				keyIsNotTab
				|| windowTooNarrow
				|| windowTooWide
				|| controllerIsInactive
			) {
				return;
			}

			let nextElement;

			if (document.activeElement === end && !e.shiftKey) {
				e.preventDefault();
				nextElement = start;
			} else if (document.activeElement === start && e.shiftKey) {
				e.preventDefault();
				nextElement = end;
			} else if (!contents.includes(document.activeElement)) {
				e.preventDefault();
				nextElement = start;
			}

			nextElement && nextElement.focus();

		}

		element.addEventListener('keydown', tabListener);

		return tabListener;
	});

	return listeners;
};

export default focusLock;


// WEBPACK FOOTER //
// ./scripts/modules/focusLock.js